<template>
  <div id="header">
    <img class="logo" src="@/assets/LogoPiscoBlack.svg" alt="Pisco Sistemas" />
  </div>
</template>

<script>
export default {
  name: "PageHeader",
};
</script>

<style lang="scss" scoped>
#header {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #d1e8ff;
  flex: 0 0 auto;

  .logo {
    display: block;
    width: 280px;
    height: 140px;
    z-index: 1;
    flex: 0 0 auto;
  }
}

@media only screen and (min-width: 670px) {
  #header {
    height: 254px;

    .logo {
      width: 400px;
      height: 200px;
      z-index: 1;
    }
  }
}
</style>
